import axios from "axios";
// axios.defaults.headers['X-Requested-With'] = 'XMLHttpRequest';
// axios.defaults.withCredentials = false;
import { BASE_HOST } from "@/api/config";
import ENV from "@/plugin/env";
// let running_queue = []; //声明一个数组用于存储每个ajax请求的取消函数和ajax标识
import rq from "@/api/request-queue";
import bus from "@/plugin/bus";
const instance = axios.create();

var API = {};
let init_config = localStorage.getItem('init_config');
let o = init_config ? JSON.parse(init_config) : {}
//添加请求拦截器
instance.interceptors.request.use(
    function (config) {
        if (config.headers) {
            for (let k in config.headers) {
                config.headers[k] = config.headers[k];
            }
            if (!o.stat_id) {
                init_config = localStorage.getItem('init_config');
                o = init_config ? JSON.parse(init_config) : {}
            }
            if(o.stat_id){
                config.headers['afd-stat-id'] = o.stat_id;
            }
            config.headers['afd-fe-version'] = 20220508;
        }
        config.headers['locale-lang'] = localStorage.getItem('locale_lang') || 'zh-CN'

        if (config.name) {
            rq.push(config.name);
        }
        return config;
    },
    function (error) {
        //请求错误时做些事
        return Promise.reject(error);
    }
);

//添加响应拦截器
instance.interceptors.response.use(
    function (response) {
        //对响应数据做些事
        if(response.data && response.data.ec == 40102){
          bus.$emit(`NEED_BIND_PHONE_IN_WECHAT`);
        }
        if(response.data && response.data.ec == 40103){
          bus.$emit(`NEED_BIND_PHONE`);
        }
        // let name = response.config.name;
        // let data = response.data;
        // let go = setTimeout(() => {
        //     rq.remove(name, data);
        //     name = null;
        //     data = null;
        //     clearTimeout(go);
        // },30)
        rq.remove(response.config.name, response.data)
        if (response.data) {
            response = response.data;
        }
        return response;
    },
    function (error) {
        //请求错误时做些事
        return Promise.reject(error);
    }
);

export function $axios(api, data) {
    let host = "";

    let post_data = {}; //防止污染模板参数
    if (api.data && data) {
        for (let k in api.data) {
            if (api.data[k] != undefined) {
                post_data[k] = api.data[k]; //模板参数默认值
            }
            if (data[k] != undefined) {
                post_data[k] = data[k]; //业务参数
            }
        }

        for (let j in data) {
            //如果有传多余参数，会提示
            if (api.data[j] == undefined) {
                console.log(`${api.name} 配置项缺少参数: ${j}`);
            }
        }
    }

    if (!global.window && !!process && process.env.NODE_ENV == "development") {
        //ssr 没有代理，需要自己补全
        host = BASE_HOST;
    }
    if (ENV.is_afd_client && ENV.is_ios && ENV.is_pro) {
        //ios因为证书卡，暂时放弃https
        // host = 'http://afdian.net';
    }

    let config = {
        method: api.method || "get",
        url: host + api.url,
        name: api.name,
        headers: api.headers || {},
    };

    if (api.method == "post") {
        config.data = post_data;
    } else {
        config.params = post_data;
    }
    return instance(config);
}
export function $axios_all(axios_list) {
    return axios.all(axios_list);
}

export function is_run(api) {
    return rq.queue.includes(api.name);
}
